import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function CalendarListIcon(props: SvgIconProps) {
  const { fill = "white", ...otherProps } = props;

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...otherProps}
    >
      <svg>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.32 2.3C14.41 2.55 16.04 4.52 16.04 6.96H16.05V9.15H14.71V8.26H1.35001V13.29C1.35001 15.06 2.61001 16.49 4.17001 16.49H8.28001L8.26001 18.01H4.17001C1.87001 18 0.0100098 15.9 0.0100098 13.29V6.97C0.0100098 4.52 1.64001 2.55 3.74001 2.3V0.75C3.74001 0.34 4.07001 0 4.47001 0C4.87001 0 5.20001 0.34 5.20001 0.75V2.25H10.86V0.75C10.86 0.34 11.19 0 11.59 0C11.99 0 12.32 0.34 12.32 0.75V2.3ZM3.72001 3.82C2.43001 4.04 1.42001 5.25 1.34001 6.76H14.68C14.6 5.26 13.59 4.05 12.3 3.82V5.17C12.3 5.58 11.97 5.92 11.57 5.92C11.17 5.92 10.84 5.58 10.84 5.17V3.77H5.17001V5.17C5.17001 5.58 4.84001 5.92 4.44001 5.92C4.04001 5.92 3.71001 5.58 3.71001 5.17V3.82H3.72001ZM8.55001 12.07H17.34C17.71 12.07 17.99 11.78 17.99 11.4C17.99 11.02 17.7 10.73 17.34 10.73H8.55001C8.19001 10.73 7.90001 11.02 7.90001 11.4C7.90001 11.78 8.19001 12.07 8.55001 12.07ZM8.55001 14.92H17.34C17.71 14.92 17.99 14.63 17.99 14.25C17.99 13.87 17.7 13.58 17.34 13.58H8.55001C8.19001 13.58 7.90001 13.87 7.90001 14.25C7.90001 14.63 8.19001 14.92 8.55001 14.92ZM17.35 17.82H12.31C11.95 17.82 11.66 17.53 11.66 17.15C11.66 16.77 11.95 16.48 12.31 16.48H17.35C17.72 16.48 18 16.77 18 17.15C18 17.53 17.71 17.82 17.35 17.82Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  );
}
